export const productInputProps = {
  eanCode: { maxLength: 20 },
  providerMainCode: { maxLength: 6 },
  description1: { maxLength: 25 },
  description2: { maxLength: 50 },
  size: { maxLength: 8 },
  measurementUnit: { maxLength: 8 },
  temperature: { maxLength: 15 },
  allergens: { maxLength: 500 }
}
